export interface PredefinedProduct {
  productCode: string;
  productName: string;
  productAmount: string;
}

export const DUMMY_PRODUCTS: PredefinedProduct[] = [
  { productCode: "PRD001", productName: "Product 1", productAmount: "250" },
  { productCode: "PRD002", productName: "Product 2", productAmount: "450" },
  { productCode: "PRD003", productName: "Product 3", productAmount: "180" },
  { productCode: "PRD004", productName: "Product 4", productAmount: "320" },
  { productCode: "PRD005", productName: "Product 5", productAmount: "280" },
  { productCode: "PRD006", productName: "Product 6", productAmount: "120" },
];

/** Format product amount for display (no points label) */
export function formatAmount(amount: string | number): string {
  const value = typeof amount === "string" ? Number(amount) : amount;
  if (Number.isNaN(value)) return "0";
  return value.toLocaleString("en-US", {
    maximumFractionDigits: 0,
  });
}

export const TRANSACTION_TYPE_OPTIONS = [
  { value: "Earn", label: "Earn" },
  { value: "Burn", label: "Burn" },
];
